<template>
	<div id="m_wdxz">
		<div class="g-ypxx">
			<div class="time">
				<quill-editor v-model="describe" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
				 @ready="onEditorReady($event)">
				</quill-editor>
			</div>
			<center><input @click="addtext" type="button" class="g-btn" value="保存"></center>

		</div>

	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	import {
		quillEditor
	} from 'vue-quill-editor'

	export default {
		data() {
			return {
				describe: storage.get('film_works'),
				uid: storage.get('userdata'),
				editorOption: {
					modules: {
						toolbar: [
							['clean']
							],
					}
				}
			}
		},
		components: {
			quillEditor
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		mounted() {

		},
		methods: {
			onEditorBlur(quill) {

			},
			onEditorFocus(quill) {

			},
			onEditorReady(quill) {

			},
			onEditorChange({
				quill,
				html,
				text
			}) {

				this.describe = html
			},
			addtext() {

				var api = "https://api.yopoo.cn/api/centre/describe"
				let infor = {
					describe: this.describe,
					category: 1,
					artistId: storage.get('userdata')
				}
				Axios.post(api, infor).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						})
						setTimeout(() => {
							location.reload()
						}, 500)

					}
					if (res.data.code == 202) {
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true
						})
					}

				})



			},
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/per_admin/per_modify/M_Film.vue